/** Simple SVG shown when a product image URL is missing or failed to load. */
export default function ProductImagePlaceholder({ label = 'Image not found', className = 'image-fallback' }) {
  return (
    <div className={className} role="img" aria-label={label}>
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" aria-hidden="true">
        <rect x="3" y="3" width="18" height="18" rx="2" />
        <circle cx="8.5" cy="8.5" r="1.5" fill="currentColor" stroke="none" />
        <path d="M21 15l-5-5L5 21" />
        <path d="M4 4l16 16" strokeLinecap="round" />
      </svg>
      {label ? <span>{label}</span> : null}
    </div>
  );
}
